// Accept editing states and up to two decimal places. Never strip letters or
// grouping separators into a different amount; commas mean decimal separators.
export const normalizeAmountInput = (value: string): string | null => {
  const normalized = value.replace(",", ".")
  return /^\d*(?:\.\d{0,2})?$/.test(normalized) ? normalized : null
}
